import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=b9bd324a&scoped=true&"
import script from "./BasePopup.vue?vue&type=script&lang=js&"
export * from "./BasePopup.vue?vue&type=script&lang=js&"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=b9bd324a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bd324a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9bd324a')) {
      api.createRecord('b9bd324a', component.options)
    } else {
      api.reload('b9bd324a', component.options)
    }
    module.hot.accept("./BasePopup.vue?vue&type=template&id=b9bd324a&scoped=true&", function () {
      api.rerender('b9bd324a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BasePopup.vue"
export default component.exports